import fc from 'format-currency';

const FormatCurrency = {
  methods: {
    formatCurrency(value, date=new Date()){
      var eurkn = 7.53450;
      if (typeof date == 'string'){
        var temp = date;
        date = new Date(date.split('.').reverse());
        if(date=="Invalid Date"){
          date = new Date(temp);
        }
      }
      return fc(value, {'locale': 'hr-HR'}) + '€'
      if(new Date(date.toLocaleString('en', {timeZone: 'Europe/Zagreb'})) >= new Date(new Date(2023, 0, 1).toLocaleString('en', {timeZone: 'Europe/Zagreb'}))){ //matija: maknuti nakon duplog iskazivanja
      	return fc(value, {'locale': 'hr-HR'}) + ' € | ' + fc(value * eurkn, {'locale': 'hr-HR'}) + ' kn'
      }
      return fc(value / eurkn, {'locale': 'hr-HR'}) + ' € | ' + fc(value, {'locale':'hr-HR'}) + ' kn'
    }
  }
}

export default FormatCurrency;



// WEBPACK FOOTER //
// ./src/mixins/format-currency.js